import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({trigger}) {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instantly scroll to top
    window.scrollTo(0, 0);

    // Temporarily disable header transition
    const header = document.querySelector(".site-header");
    if (header) {
      header.style.transition = "none";
      header.classList.add("visible"); // ensure it's expanded immediately

      // Force reflow so the browser applies the "no transition" instantly
      void header.offsetHeight;

      // Re-enable transitions after a short delay
      setTimeout(() => {
        header.style.transition = "";
      }, 100);
    }
  }, [pathname, trigger]);

  return null;

  // const {pathname} = useLocation();

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth"  
  //   });
  // }, [pathname]);

  // return null;
}